import { useTranslation } from 'react-i18next';
import { PageHeader, Section } from '../../components/page.tsx';
import { Notice } from '../../components/ui.tsx';
import { activeLease, useLeases } from '../../lib/tenancy.ts';
import { ContactSettings } from '../shared/ContactSettings.tsx';
import { LeaseParties } from '../shared/LeaseView.tsx';
import { Occupants } from '../shared/Occupants.tsx';
import { useTenant } from './TenantShell.tsx';

/**
 * Vuokralaisen omat tiedot: yhteystiedot ja asunnossa asuvat. Sopimuksen vuokralaiset
 * näkyvät automaattisesti; muut asukkaat ja lemmikit vuokralainen päivittää itse.
 * Vuokranantaja näkee kaiken tämän, joten se kerrotaan suoraan.
 */
export function TenantSettingsPage() {
  const { t } = useTranslation();
  const { current } = useTenant();
  const { data: leases } = useLeases(current?.id);
  const lease = activeLease(leases);
  return (
    <>
      <PageHeader title={t('nav.settings')} />
      <div style={{ display: 'grid', gap: '2rem' }}>
        <div style={{ display: 'grid', gap: '1.25rem' }}>
          <Notice>{t('tenant.settingsNote')}</Notice>
          <ContactSettings />
        </div>
        {lease && (
          <Section title={t('occupants.title')} note={t('occupants.noteTenant')}>
            <div style={{ display: 'grid', gap: '1rem' }}>
              <LeaseParties lease={lease} />
              <Occupants lease={lease} editable />
            </div>
          </Section>
        )}
      </div>
    </>
  );
}
